var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table table-borderless table-striped" }, [
    _c("tbody", [
      _c("tr", [
        _c("td", [_vm._v("E-Waybill")]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(_vm.ewaybill.ewb))])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Consignor")]),
        _vm._v(" "),
        _c("td", [
          _vm._v(_vm._s(_vm.ewaybill.consignorGst)),
          _c("br"),
          _vm._v("\n      " + _vm._s(_vm.ewaybill.consignorAddr) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Consignee")]),
        _vm._v(" "),
        _c("td", [
          _vm._v(_vm._s(_vm.ewaybill.consigneeGst)),
          _c("br"),
          _vm._v("\n      " + _vm._s(_vm.ewaybill.consigneeAddr) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Invoice")]),
        _vm._v(" "),
        _c("td", [
          _vm._v(_vm._s(_vm.ewaybill.invoiceNo)),
          _c("br"),
          _vm._v(
            "\n      " + _vm._s(_vm._f("date")(_vm.ewaybill.invoiceDt)) + " "
          ),
          _c("br"),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-rupee-sign" }),
          _vm._v("    " + _vm._s(_vm.ewaybill.invoiceVal) + " "),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Transporter")]),
        _vm._v(" "),
        _c("td", [
          _vm._v(_vm._s(_vm.ewaybill.transporterId) + " "),
          _vm.ewaybill.awb
            ? _c("span", [
                _vm._v(
                  "– " +
                    _vm._s(_vm.ewaybill.awb) +
                    " – " +
                    _vm._s(_vm.ewaybill.deliveryStatus)
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("Status")]),
        _vm._v(" "),
        _c("td", [
          _vm.ewaybill.cancelled === true
            ? _c("span", [
                _vm._v("Cancelled "),
                _c("i", { staticClass: "fa fa-times-square text-danger" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ewaybill.validTill !== null && !_vm.expired
            ? _c("span", [
                _vm._v("Active "),
                _c("i", { staticClass: "fa fa-check-circle text-success" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.ewaybill.validTill === null
            ? _c("span", [
                _vm._v("No Part-B "),
                _c("i", { staticClass: "fa fa-check-circle text-danger" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.expired
            ? _c("span", [
                _vm._v("Expired "),
                _c("i", { staticClass: "fa fa-times-circle text-danger" })
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91176b74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91176b74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BasicEWBDetails.vue
// module id = null
// module chunks = 